import * as React from 'react';
import { Field } from 'redux-form';
import NumberFormat from 'react-number-format';

import { FormInput } from '@inqool/uas-web-core/es/components/controls/Input';
import { formNumberInputWrapper } from '@utils/utils';

import * as T from '@components/form/Input/_inputTypes';

const Input: React.SFC<T.OutterProps & T.InnerProps> = props => (
  <FormInput
    {...props}
    onBlur={props.input.onBlur}
    onFocus={props.input.onFocus}
    fullWidth={true}
    floatingLabelText={props.label}
  />
);

export default Input;

export const FormattedNumberInput = formNumberInputWrapper(NumberFormat);

export class InputField extends Field<T.OutterCustomProps> {}



// WEBPACK FOOTER //
// ./src/components/form/Input/Input.tsx